const RightQuick = () => {
  return (
    <div className="grid fixed right-2 bottom-44 lg:bottom-36 lg:right-[calc((100%-var(--container))/3)] lg:translate-x-5 w-fit h-fit z-10 justify-items-center gap-2 lg:gap-4">
      <button
        type="button"
        onClick={() => window.open("https://open.kakao.com/o/sNpgnxNi")}
        className="transition hover:scale-[1.02] active:scale-[0.98]"
      >
        <img
          src="/images/iconKakao.png"
          alt="하수코솔루션 빠른 견적 문의"
          className="!relative w-auto h-full max-h-12 lg:max-h-16 object-contain"
        />
      </button>{" "}
      <button
        type="button"
        onClick={() => window.open("https://blog.naver.com/pkpk1440")}
        className="transition hover:scale-[1.02] active:scale-[0.98]"
      >
        <img
          src="/images/iconNaver.png"
          alt="하수코솔루션 블로그"
          className="!relative w-auto h-full max-h-12 lg:max-h-16 object-contain"
        />
      </button>
    </div>
  );
};

export default RightQuick;
